import { castleAirInstance } from "../../shared_elements/components";

export const formTemplateHd = [
    {label:'Ref. No.', sortOption:false, width:'50px'},
    {id:'name', label:'Name', sortOption:true},
    {id:'type', label:'Form Type', sortOption:true, width:'60px'},
    {label:'Description', sortOption:false},    
    {label:'Attachment', sortOption:false},
    {label:'Created By', sortOption:false},
    {id:'created_at',label:'Created At', sortOption:true, width:'60px'},
    {label:'Action(s)', sortOption:false, actionCell:true, width:'60px'}
];
export const templateObj = {
    name:'',
    description:'',
    file:[],
    type:null,
    is_section_template :castleAirInstance ? true : false,
    t004_sync_form :[]
}
export const templateFilterOptions = {
    'name': {
        'inputType': 'text',
        'placeholder': 'Search by Template Name',
        'title': 'Template Name'
    },
    'type': {
        'inputType': 'dropdown',
        'title': 'Form Type',
        'options':[],
        'labelKey':'name',
        'valueKey':'name',
        'multiple': true
    }
};